<div style="height: 100%">
  <div class="app-grid">
    <s11-header></s11-header>
    <div class="s11-full-size">
      <s11-firebase-wrapper> </s11-firebase-wrapper>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
